import React from 'react';
import { HonoraryMembership, honoraryOnDate, honoraryPeriod } from '../utils/honoraryMembership';
export default function HonoraryMembershipBadge({ member }: { member: HonoraryMembership }) {
  if (!member.ehrenmitglied_ab) return null;
  return <span title={honoraryPeriod(member)} className="inline-flex shrink-0 items-center rounded-md border border-warning-200 bg-warning-50 px-2 py-0.5 text-[11px] font-semibold text-warning-800 dark:border-warning-800 dark:bg-warning-900/20 dark:text-warning-300">{honoraryOnDate(member) ? 'Ehrenmitglied' : 'Ehrenmitgliedschaft'}</span>;
}
